import React from 'react';

import IndustrySolutions from 'components/pages/IndustrySolutions';
import { publisherSolution } from 'components/pages/AudienceSolutions/data';

const Publishers: React.FC = () => <IndustrySolutions solution={publisherSolution} />;

export default Publishers;
